import Media from 'react-media';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';

interface Props {
    imgSrc: string,
    imgTitle?: string;
    imgDescription?: string;
}

const GameImage = ({ imgSrc, imgTitle, imgDescription }: Props) => {
    const [imgIsLoading, setImgIsLoading] = useState(true);
   
    useEffect(() => {
        setImgIsLoading(true);
    }, [imgSrc])

    const title = <h3 className="mb-[7px] font-bold text-[24px] lg:text-[36px] lg:leading-[44px]">{imgTitle}</h3>;
    const description = <p className="text-[14px] leading-normal lg:text-[16px] lg:leading-[22px] text-center m-0">{imgDescription}</p>
    const imgCaptionLargeScreen = <div className="caption-class absolute bottom-[15px] left-1/2 -translate-x-1/2 w-11/12 text-center pt-[19px] pb-[19px] pl-[41px] pr-[41px] bg-[#101010]/[.6] rounded-[3px] text-white ">
                            {imgTitle && title}
                            {imgDescription && description}
                        </div>
    const imgCaptionMobileScreen = <div className='caption-class text-[#252429] text-center mb-[20px]'>
                                {imgTitle && title}
                                {imgDescription && description}
                            </div>;

    const antIconLarge = <LoadingOutlined className='text-[#DC3545]' style={{ fontSize: "94px" }} spin />;
    
    const largeScreen = <div className="relative mb-[20px] h-fit w-fit min-w-full mx-auto">
                            <Spin indicator={antIconLarge} spinning={imgIsLoading}>
                                <img className="img-class w-full object-cover" src={imgSrc} alt="Slide" onLoad={()=>setImgIsLoading(false)}/>
                            </Spin>                    
                            {(imgTitle || imgDescription) && !imgIsLoading && imgCaptionLargeScreen}
                        </div>;

    const antIconMobile = <LoadingOutlined className='text-[#DC3545]' style={{ fontSize: "34px" }} spin />;
    
    const mobiletScreen = <div>
                            <div className="mb-[20px] h-fit mx-auto">
                                <Spin indicator={antIconMobile} spinning={imgIsLoading}>
                                    <img className="img-class w-full object-contain" src={imgSrc} alt="Slide" onLoad={()=>setImgIsLoading(false)}/>
                                </Spin>
                            </div>
                            {(imgTitle || imgDescription) && !imgIsLoading && imgCaptionMobileScreen}
    </div>;

    return (
            <Media queries={{ small: "(max-width: 1023px)" }}>
                {matches => matches.small ? mobiletScreen : largeScreen}
            </Media>
    )
}

export default GameImage;